import React from 'react';
import { Navigate } from 'react-router-dom';

const RoleProtectedRoute = ({ children, allowed, isAuthenticated, role }) => {
  console.log('RoleProtectedRoute check:', { isAuthenticated, role, allowed });

  if (!isAuthenticated) {
    console.log('User not authenticated, redirecting to login');
    return <Navigate to="/login" />;
  }

  const isAllowed = Array.isArray(allowed) ? allowed.includes(role) : role === allowed;
  console.log('Role check result:', { isAllowed, role, allowed });
  
  return isAllowed ? children : <Navigate to="/unauthorized" />;
};

export default RoleProtectedRoute;